import React from "react";
import { ExternalLink, Link2 } from "lucide-react";

export function externalVideoEmbedUrl(rawUrl) {
  try {
    const url = new URL(rawUrl);
    const host = url.hostname.toLowerCase().replace(/^www\./, "");
    if (host === "youtu.be") {
      const id = url.pathname.split("/").filter(Boolean)[0];
      return /^[A-Za-z0-9_-]{6,20}$/.test(id || "") ? `https://www.youtube-nocookie.com/embed/${id}` : "";
    }
    if (host === "youtube.com" || host === "m.youtube.com") {
      const parts = url.pathname.split("/").filter(Boolean);
      const id = url.searchParams.get("v")
        || (["shorts", "embed", "live"].includes(parts[0]) ? parts[1] : "");
      return /^[A-Za-z0-9_-]{6,20}$/.test(id || "") ? `https://www.youtube-nocookie.com/embed/${id}` : "";
    }
    if (host === "vimeo.com" || host === "player.vimeo.com") {
      const id = url.pathname.split("/").filter(Boolean).find((part) => /^\d{5,12}$/.test(part));
      return id ? `https://player.vimeo.com/video/${id}` : "";
    }
  } catch {
    return "";
  }
  return "";
}

export function ExternalVideoPreview({ url, provider, interactive = true }) {
  const embedUrl = externalVideoEmbedUrl(url);
  if (!embedUrl) {
    return <a href={url} target="_blank" rel="noopener noreferrer" className="flex h-full w-full items-center justify-center p-2 text-center text-xs font-semibold hover:text-primary"><Link2 size={15} className="mr-1 shrink-0" />Apri video su {provider || "piattaforma attendibile"}</a>;
  }
  return <div className="relative h-full w-full overflow-hidden bg-black">
    <iframe
      src={embedUrl}
      title={`Anteprima video ${provider || "esterno"}`}
      loading="lazy"
      className={`h-full w-full border-0 ${interactive ? "" : "pointer-events-none"}`}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      referrerPolicy="strict-origin-when-cross-origin"
    />
    {!interactive && <div className="absolute inset-0 bg-transparent" aria-hidden="true" />}
    <a href={url} target="_blank" rel="noopener noreferrer" className="absolute bottom-1 left-1 z-10 inline-flex items-center gap-1 rounded bg-black/75 px-2 py-1 text-[10px] font-semibold text-white" onClick={(event) => event.stopPropagation()}>
      <ExternalLink size={11} /> Apri
    </a>
  </div>;
}
